module.exports = __webpack_public_path__ + "static/media/header.cf4f7bd2.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/header.jpg
// module id = 1367
// module chunks = 0